import { render } from "./editRecord.vue?vue&type=template&id=ac581bfc&scoped=true"
import script from "./editRecord.vue?vue&type=script&lang=js"
export * from "./editRecord.vue?vue&type=script&lang=js"

import "./editRecord.vue?vue&type=style&index=0&id=ac581bfc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac581bfc"],['__file',"src/views/aiProduct/components/editRecord.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac581bfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac581bfc', __exports__)) {
    console.log('reload')
    api.reload('ac581bfc', __exports__)
  }
  
  module.hot.accept("./editRecord.vue?vue&type=template&id=ac581bfc&scoped=true", () => {
    console.log('re-render')
    api.rerender('ac581bfc', render)
  })

}


export default __exports__